import { t as e } from "./cx-BjmrJCen.js";
/* empty css                              */
/* empty css                             */
import { Fragment as t, jsx as n, jsxs as r } from "react/jsx-runtime";
//#region src/components/brand/brand.css.ts
var i = "_2kaylz0", a = "_2kaylz2", o = "_2kaylz3", s = "_2kaylz4", c = "_2kaylz5", l = "_2kaylz6", u = "_2kaylz7 _8zp7se2";
//#endregion
//#region src/components/brand/brand.tsx
function d({ children: a, className: o, ...s }) {
	return /* @__PURE__ */ n("div", {
		...s,
		className: e(i, o),
		children: a ?? /* @__PURE__ */ r(t, { children: [
			/* @__PURE__ */ n("span", { className: "_2kaylz1" }),
			/* @__PURE__ */ n("span", { className: "_2kaylz1" }),
			/* @__PURE__ */ n("span", { className: "_2kaylz1" }),
			/* @__PURE__ */ n("span", { className: "_2kaylz1" })
		] })
	});
}
function f({ className: i, subtitle: f, title: p = "TaskGuard", ...m }) {
	return /* @__PURE__ */ r("div", {
		...m,
		className: e(a, i),
		children: [/* @__PURE__ */ n(d, { "aria-hidden": "true" }), /* @__PURE__ */ r("div", {
			className: o,
			children: [/* @__PURE__ */ n("strong", {
				className: s,
				children: p === "TaskGuard" ? /* @__PURE__ */ r(t, { children: [/* @__PURE__ */ n("span", {
					className: c,
					children: "Task"
				}), /* @__PURE__ */ n("span", {
					className: l,
					children: "Guard"
				})] }) : p
			}), f ? /* @__PURE__ */ n("span", {
				className: u,
				children: f
			}) : null]
		})]
	});
}
//#endregion
export { f as BrandLogo, d as BrandMark };

//# sourceMappingURL=brand.js.map